import { ProductItemResponse } from '@/api/product/types';

export const getArticleName = (products?: ProductItemResponse[] | null, productId?: string | null): string => {
	if (!productId || !products) return '';

	for (const product of products) {
		if (product.id === productId || product.itemNo === productId) return product.name;

		const variant =
			product.variants?.find((variant) => variant.id === productId) ??
			product.skus?.find((sku) => sku.id === productId || sku.skuNo === productId);
		if (variant) return variant.name || '';
	}

	return '';
};
